module.exports = __webpack_public_path__ + "img/ЗВ-13(КВ)-007-m.0d0d30b0.png";